import Button from 'components/Button/Button';
import FormInput from 'components/Input/FormInput';
import { ICreateTeaserTotalSchedule } from 'modules/Teasers/CreateTeaser/createTeaserState/createTeaserContext';
import React, { useCallback } from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './AdditionalScheduleInput.module.scss';

interface IAdditionalScheduleInput {
	fieldId: string;
	totalSchedules: ICreateTeaserTotalSchedule[];
	changeAdditionalSchedule: (fieldId: string, value: string) => void;
	setSchedules: (value: ICreateTeaserTotalSchedule[]) => void;
}

const AdditionalScheduleInput: React.FC<IAdditionalScheduleInput> = ({
	fieldId,
	totalSchedules,
	changeAdditionalSchedule,
	setSchedules,
}) => {
	const handleChange = useCallback(
		(value: string) => {
			changeAdditionalSchedule(fieldId, value);
		},
		[changeAdditionalSchedule],
	);

	const handleDeleteField = useCallback(() => {
		const updatedSchedules = totalSchedules.filter((el) => el.id !== fieldId);
		setSchedules(updatedSchedules);
	}, [totalSchedules, setSchedules]);

	return (
		<div className={style.container}>
			<FormInput
				testId={`AdditionalScheduleInput-${fieldId}`}
				name={`additionalSchedule-${fieldId}`}
				label="activationScheduleLabel"
				placeholder="cronExpressionInputPlaceholder"
				maxLength={128}
				onChange={handleChange}
			/>
			<Button
				className={style.button}
				theme="clear"
				icon={
					<svg className={style.closeIcon} onClick={handleDeleteField}>
						<use xlinkHref={`${breadcrumbs}#crossMark`} />
					</svg>
				}
			/>
		</div>
	);
};

export default React.memo(AdditionalScheduleInput);
